export default __webpack_public_path__ + "static/bike-3a20f57bd95d7b123080bc3d119dde3f.png";